import Content from './pilotContent';
import FastEvent from '@shared/classes/fastEvent';
import NextEpisode from '@components/elements/nextEpisode/nextEpisode';
import { PilotType } from '@shared/types/props/pilot';

export default function PilotVod({ asset }: { asset: FastEvent }) {
  return (
    <div>
      <Content
        currentChannel={asset?.channel}
        currentEvent={asset}
        type={PilotType.VOD}
      />
      <NextEpisode />
    </div>
  );
}
